import type { ReactNode } from "react";

interface CardProps {
  title?: string;
  subtitle?: string;
  children: ReactNode;
}

export function Card({ title, subtitle, children }: CardProps): JSX.Element {
  return (
    <section className="card" aria-labelledby={title ? "card-title" : undefined}>
      {title ? (
        <header className="card__header">
          <h1 id="card-title" className="card__title">
            {title}
          </h1>
          {subtitle ? <p className="card__subtitle">{subtitle}</p> : null}
        </header>
      ) : null}
      <div className="card__body">{children}</div>
    </section>
  );
}
